export default __webpack_public_path__ + "static/media/terms-cat.9757e932.png";